import { SpainIcon, UkIcon } from "../../assets/SvgIcons"

export const LANGUAGES = {
  en: { icon: UkIcon, code: "en", label: "English" },
  es: { icon: SpainIcon, code: "es", label: "Español" },
} as const
